import {SET_COMPANY_DATA} from "./types";

export const setCompanyData = (data, company) => {
    return{
        type: SET_COMPANY_DATA,
        payload: {
            company,
            data,
        }
    }
}